export var ReportView;
(function (ReportView) {
    ReportView[ReportView["Data"] = 0] = "Data";
    ReportView[ReportView["Matrix"] = 1] = "Matrix";
    ReportView[ReportView["Blurb"] = 2] = "Blurb";
    ReportView[ReportView["Text"] = 3] = "Text";
    ReportView[ReportView["Cells"] = 4] = "Cells";
    ReportView[ReportView["Calendar"] = 5] = "Calendar";
    ReportView[ReportView["Tiles"] = 6] = "Tiles";
    ReportView[ReportView["Charts"] = 7] = "Charts";
    ReportView[ReportView["HierarchicalView"] = 8] = "HierarchicalView";
    ReportView[ReportView["ColumnsView"] = 9] = "ColumnsView";
})(ReportView || (ReportView = {}));
;
